import { useTranslation } from 'react-i18next';

import { USER_ROLES } from '@features/auth/utils/constants.ts';
import { DataStatus } from '@shared/components/DataStatus/DataStatus.tsx';
import { InfoPanel } from '@shared/components/InfoPanel/InfoPanel.tsx';
import { InfoPanelTypes } from '@shared/components/InfoPanel/InfoPanel.types.ts';
import { Item } from '@shared/components/Review/Item/Item.tsx';
import { i18nNameSpace } from '@shared/consts/i18n.ts';
import { UserProfileResponse } from '@shared/services/userProfile/service.types.ts';

import styles from './Review.module.scss';

interface ReviewProps {
  data: UserProfileResponse | null;
  isFormVisible: boolean;
  isUserProfileDataApproved: boolean;
  isBillingInfoProvided: boolean;
}

export function Review({ data, isFormVisible, isBillingInfoProvided }: ReviewProps) {
  const { t } = useTranslation(i18nNameSpace.USERS);

  if (!data) {
    return null;
  }

  const isExternalDirectClient = data.role === USER_ROLES.EXTERNAL_DIRECT_CLIENT;
  const statusTranslationKey = data.status.toLowerCase();
  const isCompanyNameNotExists = !data.companyName;

  return (
    <div className={styles.wrapper}>
      {isExternalDirectClient && !isBillingInfoProvided && (
        <p className={styles.text}>{t('page.adminPanel.body.campaignSubmissionInfo')}</p>
      )}
      <div className='grid'>
        <div className='row'>
          <div className='col-12'>
            <Item label={t('page.adminPanel.formFields.companyName.label')} value={data.companyName || '-'} />

            {isCompanyNameNotExists && (
              <InfoPanel type={InfoPanelTypes.INFO} className={styles.infoPanel}>
                <p>{t('page.adminPanel.infoPanels.campaignNameStatus')}</p>
              </InfoPanel>
            )}
          </div>
        </div>
        <div className='row'>
          <div className='col-6'>
            <Item
              label={t('page.adminPanel.formFields.email.label')}
              value={data.email}
              className={styles.lineBreakAnywhere}
            />
          </div>
          <div className='col-6'>
            <Item label={t('page.adminPanel.formFields.status.label')}>
              <DataStatus
                variant={data.status}
                textLabel={t(`dataStatus.${statusTranslationKey}`, { ns: i18nNameSpace.COMMON })}
              />
            </Item>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <hr className={styles.divider} />
          </div>
        </div>
        {!isFormVisible && (
          <div className='row'>
            <div className='col-6'>
              <Item
                label={t('page.adminPanel.formFields.invoicingEmail.label')}
                value={data.invoicingEmail}
                className={styles.lineBreakAnywhere}
              />
            </div>
            <div className='col-6'>
              <Item label={t('page.adminPanel.formFields.vatNumber.label')} value={data.vatNumber} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
